import {Component, OnChanges, Input, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {UserRoleService} from '../services/user-role.service';
import {ConstantsService} from '../../../../services/constants.service';
import {AdminService} from '../../../../services/admin.service';
import {UserRole} from 'app/types/admin-data.types';

declare const swal;
declare const toastr: any;

@Component({
    selector: 'role-item-view',
    templateUrl: './item-view.component.html',
    styleUrls: ['./item-view.component.scss']
})
export class UserRoleItem implements OnChanges {
    @ViewChild('form') form;
    @Input() itemData;
    @Input() close;
    @Input() update;
    private services: Object = {};
    public serviceNames: Array<string> = [];
    private initialItemData: any;
    public currentUserRoles = [];
    public isCurrentRole: boolean = false;
    public isCanEdit: boolean = true;
    constructor(public userRoleService: UserRoleService, public adm: AdminService) {
    }

    ngOnChanges() {
        this.itemData = JSON.parse(JSON.stringify(this.itemData));
        this.assignData();
    }

    onSubmit(form: NgForm) {
        if (form.dirty) {
            swal(ConstantsService.getSwalConfig(
                'Update user role',
                'Are you sure you would like to save this User Role?'),
                (res) => {
                    if (res) {
                        this.update(this.itemData.id, {settings: this.itemData.settings});
                    } else {
                        this.itemData = JSON.parse(JSON.stringify(this.initialItemData));
                        this.assignData();
                    }
                }
            );
        }
    }

    remove() {
        if(this.itemData.numberOfUsers === 0)
            this.userRoleService.remove(this.itemData.id).subscribe(() => this.close());
        else
            toastr.error('The role has active users. Please remove all users assigned to this role to delete it.');
    }

    assignData() {
        if (!this.initialItemData || this.initialItemData.id !== this.itemData.id) {
            this.initialItemData = JSON.parse(JSON.stringify(this.itemData));
        }
        this.services = this.itemData.settings;
        this.serviceNames = Object.keys(this.itemData.settings);
        this.currentUserRoles = this.userRoleService.account.user.buildingPropertyManager.map(item => item.role && item.role.id);
        this.isCurrentRole = !this.userRoleService.account.isUserAdmin() && this.currentUserRoles.some(roleId => roleId == this.itemData.id);
        this.disableCheckboxes();
    }

    selectAll(type, event) {
        this.serviceNames.forEach(name => {
            this.services[name][type[0]] = event.target.checked;
        });
    }

    selectRead(event, serviceItem) {
        if (!event.target.checked) {
            this.services[serviceItem].u = false;
            this.services[serviceItem].c = false;
            this.services[serviceItem].d = false;
            this.services[serviceItem].a = false;
            this.services[serviceItem].s = false;
        }
    }

    selectUpdate(event, serviceItem, type) {
        if (type === 'c') {
            this.services[serviceItem].u = event.target.checked;
        } else {
            this.services[serviceItem].c = event.target.checked;
        }
        if (!event.target.checked) {
            this.services[serviceItem].d = false;
            this.services[serviceItem].a = false;
            this.services[serviceItem].s = false;
        }
    }

    disableCheckboxes() {
        if (!this.userRoleService.account.canUpdate('auth')) {
            Object.keys(this.form.controls).forEach(control => this.form.controls[control].disable());
        }
    }

    setCorporationNumber(data) {
        if (data.corporationNumberId) {
            data.corporationNumber = data.corporationNumberId && this.userRoleService.corporationNumberList.find(item => Number(item.id) === Number(data.corporationNumberId)).name;
        }
    }

    updateProperty(changedData) {
        this.setCorporationNumber(changedData);
        const dataKeys = Object.keys(changedData);
        this.userRoleService.update(this.itemData.id, changedData).subscribe((res: UserRole) => {
            dataKeys.forEach(key => {
                if(key in this.itemData) {
                    this.itemData[key] = changedData[key];
                }
            });
            this.userRoleService.get();
        });
    }

    checkForChanges(): boolean {
        let changed = false;
        if(this.initialItemData) {
            Object.keys(this.initialItemData.settings).forEach(key => {
                Object.keys(this.initialItemData.settings[key]).forEach(permission => {
                    if(this.initialItemData.settings[key][permission] !== this.itemData.settings[key][permission])
                        changed = true;
                });
            });
        }
        return changed;
    }

    checkAllPermissions(event, item): void {
        if(item != 'bldn')
            this.services[item].r = event.target.checked;
        this.services[item].c = event.target.checked;
        this.services[item].u = event.target.checked;
        this.services[item].d = event.target.checked;
        if(item == 'amenity' || item == 'parking_pass')
            this.services[item].a = event.target.checked;
        if(item == 'amenity' || item == 'parking_pass' || item == 'parcels' || item == 'bldn' || item == 'key_log' || item == 'service_request' || item == 'pass_on_log' || item == 'inc_report' || item == 'email_merge' || item == 'sms')
            this.services[item].s = event.target.checked;
    }

    allPermissionsAreChecked(item): boolean {
        let allChecked = false;
        if(this.services[item].r && this.services[item].c && this.services[item].u && this.services[item].d) {
            if(item == 'amenity' || item == 'parking_pass') {
                if(this.services[item].a && this.services[item].s)
                    allChecked = true;
                else
                    allChecked = false;
            } else if(item == 'parcels') {
                if(this.services[item].s)
                    allChecked = true;
                else
                    allChecked = false;
            } else
                allChecked = true;
        } else
            allChecked = false;
        return allChecked;
    }

    checkEntireColumnPermissions(event, permission): void {
        const keys = Object.keys(this.services);
        keys.forEach(key => {
            if(!(key == 'bldn' && permission == 'r') && ((permission != 'a' && permission != 's') && !(this.isCurrentRole && key === 'auth') ||
               (permission == 'a' && (key == 'amenity' || key == 'parking_pass')) ||
               (permission == 's' && (key == 'amenity' || key == 'parking_pass' || key == 'parcels' || key == 'bldn' || key == 'key_log' || key == 'service_request' || key == 'pass_on_log' || key == 'inc_report' || key == 'email_merge' || key == 'sms')))) {
                if(!((permission == 'c' || permission == 'u') && !this.services[key].r)) {
                    if(!(permission == 'd' && (!this.services[key].c || !this.services[key].u))) {
                        if(!(permission == 'a' &&
                           ((!this.services[key].c || !this.services[key].u) && (key == 'amenity' || key == 'parking_pass')))) {
                            if(!(permission == 's' && (((!this.services[key].c || !this.services[key].u) &&
                                    (key == 'amenity' || key == 'parking_pass' || key == 'parcels' || key == 'bldn' || key == 'key_log' || key == 'service_request' || key == 'pass_on_log' || key == 'inc_report' || key == 'email_merge' || key == 'sms'))))) {
                                this.services[key][permission] = event.target.checked;
                                if((permission == 'r' || permission == 'c' || permission == 'u') && !event.target.checked) {
                                    const originalRead = this.services[key].r;
                                    this.checkAllPermissions(event, key);
                                    if(permission == 'c' || permission == 'u') {
                                        this.services[key].r = originalRead;
                                    }
                                }
                                if((permission == 'c' || permission == 'u') && event.target.checked) {
                                    this.services[key].c = event.target.checked;
                                    this.services[key].u = event.target.checked;
                                }
                            }
                        }
                    }
                }
            }
        });
    }

    allInColumnAreChecked(permission): boolean {
        let allChecked = true;
        const keys = Object.keys(this.services);
        if(permission == 'a' && keys.indexOf('amenity') == -1 && keys.indexOf('parking_pass') == -1)
            allChecked = false;
        if(permission == 's' && keys.indexOf('amenity') == -1 && keys.indexOf('parking_pass') == -1 && keys.indexOf('parcels') == -1)
            allChecked = false;
        else {
            keys.forEach(key => {
                if (permission != 'a' && permission != 's') {
                    if (!this.services[key][permission] && !(key == 'bldn' && permission == 'r'))
                        allChecked = false;
                } else if (permission == 'a') {
                    if ((key == 'amenity' || key == 'parking_pass') && !this.services[key][permission])
                        allChecked = false;
                } else if (permission == 's') {
                    if ((key == 'amenity' || key == 'parking_pass' || key == 'parcels' || key == 'bldn' || key == 'key_log' || key == 'service_request' || key == 'pass_on_log' || key == 'inc_report' || key == 'sms') && !this.services[key][permission])
                        allChecked = false;
                }
            });
        }
        return allChecked;
    }

    isColumnCheckboxDisabled(): boolean {
        let disabled = false;
        if(!this.userRoleService.account.canUpdate('auth'))
            disabled = true;
        return disabled;
    }

    trackByFn(index, item) {
        return index;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/user-role/item-view/item-view.component.ts